// removed by extract-text-webpack-plugin
module.exports = {"cookieToggle":"src-components-cookieToggle----cookieToggle-module---cookieToggle---1VuIn","header":"src-components-cookieToggle----cookieToggle-module---header---3PRE_","toggleDetails":"src-components-cookieToggle----cookieToggle-module---toggleDetails---1sbCj","chevron":"src-components-cookieToggle----cookieToggle-module---chevron---3U22s","open":"src-components-cookieToggle----cookieToggle-module---open---1kljE","tableWrapper":"src-components-cookieToggle----cookieToggle-module---tableWrapper---2u5Dm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cookieToggle/cookieToggle.module.scss
// module id = 284
// module chunks = 95715928098905 114276838955818